<template>
  <v-row justify="center">
    <v-card>
      <v-card-title>Create / Edit Opening hour</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="width: 600px">
        <div class="row" v-for="(day,index) in form" :key="index" style="height: 60px">
          <v-col cols="3" class="label">
            <label>{{day.day_en}}</label>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="08:00 - 18:00"
              single-line
              outlined
              dense
              full-width
              v-model="day.time"
              style="border-radius: 20px;"
              background-color="#ffffff">
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              :items="closedOption"
              background-color="#ffffff"
              outlined
              v-model="day.is_open"
              style="border-radius: 30px; text-align: left!important;"
              dense></v-select>
            <div style="display: none">{{ !day.is_open ? day.status = 'Close' : 'Open' }}</div>
          </v-col>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <div class="row text-right">
        <v-spacer></v-spacer>
        <cancel-button @click.native="cancelData" />
        <save-button label="OK" @click.native="submitData" />
      </div>
      <br />
    </v-card>
  </v-row>
</template>

<script>
    import InputTextField from "../../../components/Input/InputTextField";
    import SelectOption from "../../../components/Input/selectOption";
    import DeleteButton from "../../../components/Button/DeleteButton";
    import PreviewButton from "../../../components/Button/PreviewButton";
    import SaveButton from "../../../components/Button/SaveButton";
    import CancelButton from "../../../components/Button/CancelButton";
    import SubmitButton from "../../../components/Button/SubmitButton";
    import {mapState} from "vuex";
    export default {
        name: "OpeningHourModal",
      components: {
        SubmitButton,
        CancelButton,
        SaveButton, PreviewButton,
        DeleteButton, SelectOption, InputTextField
      },
      props: {
          openingHours: {
            default: () => []
          }
      },
      data(){
          return{
            form : [
              {
                id : '',
                day_en : 'Monday',
                time : '',
                is_open : 1,
                status : 'Open',
              },
              {
                id : '',
                day_en : 'Tuesday',
                time : '',
                is_open : 1,
                status : 'Open',
              },
              {
                id : '',
                day_en : 'Wednesday',
                time : '',
                is_open : 1,
                status : 'Open',
              },
              {
                id : '',
                day_en : 'Thursday',
                time : '',
                is_open : 1,
                status : 'Open',
              },
              {
                id : '',
                day_en : 'Friday',
                time : '',
                is_open : 1,
                status : 'Open',
              },
              {
                id : '',
                day_en : 'Saturday',
                time : '',
                is_open : 1,
                status : 'Open',
              },
              {
                id : '',
                day_en : 'Sunday',
                time : '',
                is_open : 1,
                status : 'Open',
              },
            ],
            closedOption : [
              {value : 1 , text : 'Open'},
              {value : 0 , text : 'Close'},
            ]
          }
      },
      created() {
          if(this.openingHours.length > 0){
            this.form = this.openingHours;
          }
      },
      methods:{
        submitData(){
            this.$emit('submit',this.form);
        },
        cancelData(){
          this.$emit('submit',false);
        },
      }
    }
</script>

<style scoped>
.header{
  text-align: center;
  padding: 20px;
  font-size:23px;
  font-weight: bold;
}
</style>
